import React, { useContext, useState } from 'react';
import LazyTable from 'app/component/lazy-table';
import { formatFromLocalDate } from 'app/shared/util/date-utils';
import { Button } from 'primereact/button';
import axios from 'axios';
import { ToastContext } from 'app/context/ToastContext';
import { boldNameFormatter } from 'app/shared/util/formatters';

const AgentPromotionTable: React.FC = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const [loading, setLoading] = useState(false);

  const fajkaOrNull = value => {
    if (value) {
      return (
        <span>
          <i className="pi pi-check" style={{ color: 'green', fontWeight: 'bold' }}></i>
        </span>
      );
    }

    return '';
  };

  const careerFormatter = value => {
    return value.positionNr + ' - ' + value.position;
  };

  const onGenerate = () => {
    setLoading(true);
    axios
      .get('/api/agent-promotions/generate')
      .then(r => {
        showSuccess('Úspech', 'Povýšenia boli vygenerované.');
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <h4>Zoznam vygenerovaných možností povýšenia</h4>
      <Button type="button" onClick={onGenerate}>
        Spustiť manuálne generovanie povýšení
      </Button>
      {LazyTable({
        initialSortField: 'agent.number',
        createUrl: null,
        serverUrl: '/api/agent-promotions',
        editActionAllowed: false,
        searchAllowed: false,
        globalFilterFields: [],
        externalLoading: loading,
        columns: [
          { field: 'agent.number', header: 'Číslo', sortable: true },
          {
            field: 'agent.nameFullFormatted',
            header: 'Meno poradcu',
            sortable: false,
            formatter: (_, v) => boldNameFormatter(v?.agent?.nameFullFormatted),
          },
          { field: 'careerBefore', sort: 'careerBefore.positionNr', sortable: true, header: 'Kariéra', formatter: careerFormatter },
          { field: 'nrOfPodielnikov', header: 'Počet podielnikov', sortable: true },
          { field: 'ludiaVLinii', header: 'Ľudia v línii', sortable: true },
          { field: 'promoted', header: 'Povýšenie', sortable: true, formatter: fajkaOrNull },
          { field: 'degradated', header: 'Poníženie', sortable: true, formatter: fajkaOrNull },
          { field: 'validOn', header: 'Platí ku dňu', sortable: true, formatter: formatFromLocalDate },
          { field: 'generatedOn', header: 'Generované', sortable: true, formatter: formatFromLocalDate },
        ],
      })}
    </div>
  );
};

export default AgentPromotionTable;
